// extracted by mini-css-extract-plugin
export default {"page":"Page_page__mGaS+mfq","title":"Page_title__exl3FgIe"};